import { useState } from 'react'
import Icon from './Icon'
import Trans from './Trans'

const Filterbar = props => {
  const { filtri, children, onFilter = () => {}, ordini, classes = '' } = props

  const [open, setOpen] = useState(false)

  function handleChangeOpen(filtering) {
    if (filtering) onFilter()

    if (open) {
      document.body.classList.remove('w-noscroll')
    } else {
      document.body.classList.add('w-noscroll')
    }

    setOpen(!open)
  }

  return (
    <div className={`filterbar ${open ? 'filterbar--open' : ''} ${classes}`}>
      {children ? <div className={`filterbar__top`}>{children}</div> : null}
      <div className={`filterbar__bar`}>
        <button className="filterbar__bar__cta" onClick={() => handleChangeOpen(false)}>
          <Icon id="plus" />
          <Trans chiave="Mostra filtri" />
        </button>
      </div>
      <div className={`filterbar__filters ${open ? 'filterbar__filters--open' : ''}`}>
        <div className="filterbar__filters__head">
          <Icon
            id="close"
            classes="filterbar__filters__close"
            onClick={() => handleChangeOpen(false)}
          />
        </div>
        <p className="filterbar__filters__title">
          <Trans chiave="Filtra per" />
        </p>
        <div className="filterbar__filters__list">
          {filtri}
          {ordini}
        </div>
        <div className="filterbar__filters__cta">
          <button
            className="filterbar__bar__cta button button--primary"
            onClick={() => handleChangeOpen(true)}
          >
            <Trans chiave="Applica filtri" />
          </button>
        </div>
      </div>
    </div>
  )
}

export default Filterbar
